import React, { ReactNode } from "react";
import { Space, Typography } from "antd";
import NotSet from "./NotSet";

type Props = {
	label: string | React.ReactNode;
	value?: string | number;
	children?: React.ReactNode;
	renderValue?: (value: string | number) => void;
	style?: React.CSSProperties;
	onClick?: () => void;
	strongLabel?: boolean;
	action?: ReactNode;
};
const { Text } = Typography;
const DetailItem: React.FC<Props> = ({ label, value, children, renderValue, style, onClick, strongLabel, action }) => {
	return (
		<div
			style={{ margin: "10px 0px", cursor: onClick ? "pointer" : "auto" }}
			onClick={onClick}
		>
			{typeof label === "string" ? (
				<Text
					strong={strongLabel}
					className="detail-item-title"
				>
					{label}
				</Text>
			) : (
				label
			)}
			{value !== "" && value !== undefined && value !== null ? (
				renderValue ? (
					renderValue(value)
				) : (
					<Space>
						<Text
							style={{ ...style, display: "block" }}
							strong={strongLabel}
						>
							{value}
						</Text>
						{action && action}
					</Space>
				)
			) : !children ? (
				<NotSet />
			) : (
				children
			)}
			{/* {children} */}
		</div>
	);
};
export default DetailItem;
